// extracted by mini-css-extract-plugin
module.exports = {"swatch":"InlineColorPicker_swatch__wRV_7","color":"InlineColorPicker_color__29dlC","popover":"InlineColorPicker_popover__2kkN6","cover":"InlineColorPicker_cover__2u57f"};